import { render, staticRenderFns } from "./CompanyNew.vue?vue&type=template&id=bec45fc6&"
import script from "./CompanyNew.vue?vue&type=script&lang=ts&"
export * from "./CompanyNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec45fc6')) {
      api.createRecord('bec45fc6', component.options)
    } else {
      api.reload('bec45fc6', component.options)
    }
    module.hot.accept("./CompanyNew.vue?vue&type=template&id=bec45fc6&", function () {
      api.rerender('bec45fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CompanyNew.vue"
export default component.exports